import { apiService } from '../_services'

export const companyService={
  addCompany,
  getCompany,
  logoUpload,
  getCompanyById,
  getCompanyByPage,
  bulkAdd,
  bulkUpdate,
  bulkUpdatesubBrand,
  deleteCompany,
  activeCompany,
  getZeroMarketCompanyByExchange,
  deleteZeroMarketCompanyByExchange,
  getFileUploadLogs,
  deleteFileLogById,
  bulkAddForCopyPaste
}
function getZeroMarketCompanyByExchange(exchangeId){
  return apiService.fetchAuthGet('company/zero-market?exchangeId='+exchangeId)
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}
function deleteZeroMarketCompanyByExchange(exchangeId){
  return apiService.fetchAuthPost('company/delete/zero-market?exchangeId='+exchangeId,{})
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}
function activeCompany(id,isActive){
  return apiService.fetchAuthPut('company/active/'+id+'/'+(isActive?1:0),{})
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}

function deleteCompany(id,userId){
  return apiService.fetchAuthPut('company/delete/'+id+'/'+userId,{})
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}
function deleteFileLogById(id){
  return apiService.fetchAuthPut('company/filelog/'+id,{})
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}

function addCompany(company){
  return apiService.fetchAuthPost('company',company)
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}

function getCompany(){
  return apiService.fetchAuthGet('company')
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}

function logoUpload(file){
  return apiService.fetchFilePost('file/uploadFile', file)
    .then((result) => {
      console.log(result)
      return result
    })
}
function getCompanyById(id){
  return apiService.fetchAuthGet('company/'+ id)
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}


function getCompanyByPage(start,pageSize, search,type,typeId,sortBy){
  return apiService.fetchAuthGet('company/page?start='+start+'&pageSize='+pageSize+'&search='+search+(type?('&'+type+'Id='+typeId):'')+'&sortBy='+sortBy)
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}

function getFileUploadLogs(start,pageSize){
  return apiService.fetchAuthGet('company/filelog?start='+start+'&pageSize='+pageSize)
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}

function bulkAdd(company){
  return apiService.fetchAuthPut('company/bulk',company)
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}

function bulkUpdate(company){
  return apiService.fetchAuthPut('company/bulk',company)
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}

function bulkUpdatesubBrand(company){
  return apiService.fetchAuthPut('company/bulk/subBrand',company)
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}

function bulkAddForCopyPaste(company,id){
  return apiService.fetchAuthPost('company/copyPaste/bulk/upload/'+ id,company)
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}
